import { AxiosInstance } from 'axios'
import nProgress from 'nprogress'
import { baseApiURL, apiEndPoints } from '../config'
import { AddressParams, StudentParams } from 'src/types/dataTypes'

interface DataParams {
  q: string
  pageSize: number
  pageNumber: number
  code?: string
}
export interface StatushistoryParams {
  status?: string
  studentCode?: string
  pageNumber?: number
  pageSize?: number
}

export default class Enrolment {
  apiServer: AxiosInstance
  baseUrl = `${baseApiURL}enrolment/`
  constructor(apiServer: AxiosInstance) {
    this.apiServer = apiServer
  }

  async getIntakeStudentListByIntake(params?: DataParams) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.intakeStudentList}?pageNumber=${params?.pageNumber}&&pageSize=${
      params?.pageSize
    }&intakeCode=${params?.code}`
    if (params?.q) endUrlName = `${endUrlName}&&search=${params?.q}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching RmatProgram list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async updateStudent(params: StudentParams, appCode: string) {
    nProgress.start()
    const url = `${this.baseUrl + apiEndPoints.updatestudent}/${appCode}/personalInformation`

    // url = url.replace(':appCode', appCode)
    try {
      const response = await this.apiServer.patch(url, { ...params })
      nProgress.done()

      return response
    } catch (err: any) {
      console.log('Error fetching student list ========>', err?.message)
    }
    nProgress.done()
  }
  async updateAddress(params: AddressParams, appCode: string) {
    nProgress.start()
    let url = this.baseUrl + apiEndPoints.updateaddress
    url = url.replace(':appCode', appCode)
    try {
      const response = await this.apiServer.patch(url, { ...params })
      nProgress.done()

      return response
    } catch (err: any) {
      console.log('Error fetching student list ========>', err?.message)
    }
    nProgress.done()
  }
  async getVIPStudentList(params?: DataParams) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.allVipStudent}?pageNumber=${params?.pageNumber}&pageSize=${
      params?.pageSize
    }`
    if (params?.q) endUrlName = `${endUrlName}&search=${params?.q}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response
    } catch (err: any) {
      console.log('Error fetching student list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getStudentList(params?: string) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.students}`

    try {
      const response = await this.apiServer.post(endUrlName, {
        studentCodes: params
      })

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching RmatProgram list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getSearchStudentList(params?: any) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.searchStudent}${params?.studentCodes}?pageNumber=${
      params?.pageNumber ?? 1
    }&pageSize=${params?.pageSize ?? 10}&search=${params?.search ?? ''}&programCode=${params?.programCode}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching RmatProgram list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getExportStudentList(payload?: any) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.exportStudent}?programCode=${payload?.programCode}`

    try {
      const response = await this.apiServer.post(
        endUrlName,
        {
          studentCodes: payload?.studentCodes
        },
        {
          responseType: 'blob'
        }
      )

      return response
    } catch (err: any) {
      console.log('Error fetching RmatProgram list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getUnenrolledStudentList(params?: any) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.unenrolledStudents}?pageNumber=${
      params?.pageNumber ?? 1
    }&pageSize=${params?.pageSize ?? 10}&search=${params?.q ?? ''}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching RmatProgram list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getStatusHistory(params?: StatushistoryParams) {
    let endUrlName = `${this.baseUrl + apiEndPoints.statusHistory}?studentCode=${params?.studentCode}&&pageNumber=${
      params?.pageNumber
    }&&pageSize=${params?.pageSize}`
    if (params?.status) endUrlName = `${endUrlName}&&status=${params?.status}`
    try {
      const response = await this.apiServer.get<any>(endUrlName)

      return response
    } catch (err: any) {
      console.log('Error fetching Status History list ========>', err?.message)
    }
  }
  async reggieCheckDuplicateMobile(mobileNumber: string, mobileCountryCode: string) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.reggieCheckDuplicateMobile}/${mobileCountryCode}/${mobileNumber}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data
    } catch (err: any) {
      console.error('Error checking Mobile Number ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getActivityTimelineData(applicationCode: string) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.getActivityTimeline}/${applicationCode}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data
    } catch (err: any) {
      console.error('Error fetching activity timeline Logs ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async reUploadDocument(params: any, code: string) {
    const endUrlName = `${this.baseUrl + apiEndPoints.enrolmentList}/${code}/${apiEndPoints.reUploadDocument}`
    try {
      const response = await this.apiServer.patch(endUrlName, params)

      return response.data
    } catch (err: any) {
      console.log('Error uploading document ========>', err?.message)
    }
  }
}
